import React from 'react';
import { Breadcrumb } from 'antd';
// import { Link } from 'react-router-dom';
import {
  BreadcrumbComponentItemTypes,
  BreadcrumbConfigProps,
} from '../../config/InterfacesAndTypes';
import {
  BreadcrumbItemType,
  BreadcrumbSeparatorType,
} from 'antd/es/breadcrumb/Breadcrumb';
interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbConfigProps;
}
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  // const items: React.ReactNode[] | undefined = breadcrumbs?.path?.map(
  //   (item: BreadcrumbComponentItemTypes, index: number) => (
  //     <Breadcrumb.Item key={index.toString()}>
  //       {item.link ? <Link to={item.link}>{item.name}</Link> : item.name}
  //     </Breadcrumb.Item>
  //   ),
  // );
  // return <Breadcrumb>{items}</Breadcrumb>;

  const items:
    | Partial<BreadcrumbItemType & BreadcrumbSeparatorType>[]
    | undefined =
    breadcrumbs?.path?.map(
      (item: BreadcrumbComponentItemTypes, index: number) => ({
        path: item.link,
        title: item.name as string | undefined, // Ensure it's a string or undefined
      }),
    ) ?? [];
  return <Breadcrumb items={items} />;
};

export default Breadcrumbs;
